import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuItem,
} from '@/components/ui/sidebar';

import anthosLogo from '@/assets/anthoscapital.svg';
import { AccountSwitcher } from '@/components/shared/account-switcher';
import { ReviewsCounter } from '@/components/shared/reviews-counter';
import { WhyQuench } from '@/components/shared/why-quench';

const AppSidebar = () => (
  <Sidebar className="hidden bg-white lg:block">
    <SidebarHeader className="py-6 px-4">
      <img src={anthosLogo} alt="anthos logo" className="max-h-12" />
    </SidebarHeader>
    <SidebarContent className="py-6 px-4">
      <SidebarGroup className="p-0">
        <SidebarMenu className="gap-4">
          <SidebarMenuItem>
            <AccountSwitcher />
          </SidebarMenuItem>
          <SidebarMenuItem>
            <ReviewsCounter />
          </SidebarMenuItem>
          <SidebarMenuItem>
            <WhyQuench />
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarGroup>
    </SidebarContent>
  </Sidebar>
);

export { AppSidebar };
